module.exports = __webpack_public_path__ + "static/media/cs3.784e6fc6.jpeg";